/**
 * Quantity Offers v5 → Releasit COD Form: shipping rate swap
 *
 * Form Designer rates, matched by title — never by price:
 *   Envío gratis     (0)
 *   Envío Estandar   (any Releasit amount: 6, 7, 20…)
 *   Envío Flash
 *
 * While the COD form is open, the selected Releasit offer is the source
 * of truth (not the PDP card). Free offer → Envío gratis + Flash.
 * Paid offer → Envío Estandar + Flash.
 */
(function () {
  'use strict';

  if (window.__rsiQoFreeShippingBridge) return;
  window.__rsiQoFreeShippingBridge = true;

  var STORAGE_KEY = 'rsi_qo_free_shipping';
  var FORM_SEL = '#_rsi-cod-form-modal-form';
  var ITEM_SEL = '._rsi-modal-shipping-rates-item';
  var FREE_RE = /gratis|free|sin\s*costo|sin\s*cargo/i;
  var FLASH_RE = /flash|express|24\s*horas|lightning/i;

  var state = {
    applying: false,
    programmatic: false,
    userPickedFlash: false,
    userRate: 'standard',
    lastOfferKey: '',
    applyTimer: null,
    bootTimer: null,
    ratesObserver: null,
    lastLayoutKey: '',
    formWasOpen: false,
    quietUntil: 0,
    hideStyle: null,
    offersObserver: null,
    clickedLayout: '',
    pendingLayout: '',
    driver: 'pdp',
    tapLockUntil: 0,
    enforceWindowStart: 0,
    enforceCount: 0,
  };

  function getForm() {
    return document.querySelector(FORM_SEL);
  }

  function isFormOpen() {
    var modal = document.querySelector('#_rsi-cod-form-modal');
    var form = getForm();
    if (!form) return false;
    if (window._rsiModalBus && window._rsiModalBus._isOpen) return true;
    if (modal && modal.classList.contains('_rsi-cod-form-modal-open')) return true;
    if (modal) {
      var cs = window.getComputedStyle(modal);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    }
    return !!(form.querySelector(ITEM_SEL) && (form.offsetParent || form.getClientRects().length));
  }

  function hasBundleContext() {
    var form = getForm();
    return !!(form && form.querySelector('.rb-widget, .rb-bundle-block, .rb-tier-item, .rsi-rb-offer-card'));
  }

  function getQoRoot() {
    return (
      document.querySelector('[data-qov-version="v5"]') ||
      document.querySelector('.section-quantity-offers-v5')
    );
  }

  function hasQoContext() {
    return !!(
      getQoRoot() ||
      document.querySelector(
        '.qov4__card[data-free-shipping], #rsi-cod-form-quantity-offers-hook ._rsi-quantity-offers-offer-container'
      )
    );
  }

  function qoActive() {
    return hasQoContext() && !hasBundleContext();
  }

  function parseBoolFlag(raw, fallback) {
    if (raw === true || raw === 'true' || raw === '1') return true;
    if (raw === false || raw === 'false' || raw === '0') return false;
    return fallback !== false;
  }

  function getSelectedPdpCard() {
    var root = getQoRoot();
    return root ? root.querySelector('.qov4__card--selected') : null;
  }

  function pdpCardForOfferPos(pos) {
    var root = getQoRoot();
    if (!root || pos == null || pos === '') return null;
    return root.querySelector('.qov4__card[data-offer-index="' + String(pos) + '"]');
  }

  function stampFreeShipping(isFree) {
    window._rsiQoFreeShipping = isFree !== false;
    try {
      localStorage.setItem(STORAGE_KEY, window._rsiQoFreeShipping ? '1' : '0');
    } catch (e) { /* ignore */ }
  }

  function getSelectedModalOffer() {
    return document.querySelector(
      '#rsi-cod-form-quantity-offers-hook ._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected, #_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected'
    );
  }

  function freeShippingFromEl(el) {
    if (!el || !el.hasAttribute('data-free-shipping')) return null;
    return parseBoolFlag(el.getAttribute('data-free-shipping'), true);
  }

  function getDriver() {
    if (window.__rsiQoDriver === 'pdp' || window.__rsiQoDriver === 'modal') {
      state.driver = window.__rsiQoDriver;
    }
    return state.driver;
  }

  function setDriver(name) {
    state.driver = name === 'modal' ? 'modal' : 'pdp';
    window.__rsiQoDriver = state.driver;
  }

  function getQoFreeShipping() {
    var driver = getDriver();
    if (driver === 'pdp' || !isFormOpen()) {
      var fromCard = freeShippingFromEl(getSelectedPdpCard());
      if (fromCard != null) {
        stampFreeShipping(fromCard);
        return fromCard;
      }
    }
    if (isFormOpen()) {
      var modal = getSelectedModalOffer();
      if (modal) {
        var fromModal = freeShippingFromEl(modal);
        if (fromModal != null) {
          stampFreeShipping(fromModal);
          return fromModal;
        }
        var fromPos = freeShippingFromEl(pdpCardForOfferPos(modal.getAttribute('data-offer-pos')));
        if (fromPos != null) {
          stampFreeShipping(fromPos);
          return fromPos;
        }
      }
    }
    if (typeof window._rsiQoFreeShipping === 'boolean') return window._rsiQoFreeShipping;
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored === '0' || stored === 'false') return false;
      if (stored === '1' || stored === 'true') return true;
    } catch (eAmt) { /* ignore */ }
    return true;
  }

  function wantsPaidShipping() {
    return getQoFreeShipping() === false;
  }

  function getOfferKey() {
    var driver = getDriver();
    var card;
    var idx;
    if (driver === 'pdp') {
      card = getSelectedPdpCard();
      idx = card ? String(card.getAttribute('data-offer-index') || '') : '';
      return idx + '|' + (wantsPaidShipping() ? 'paid' : 'free');
    }
    var modal = getSelectedModalOffer();
    var pos = modal ? String(modal.getAttribute('data-offer-pos') || '') : '';
    card = pos !== '' ? pdpCardForOfferPos(pos) : getSelectedPdpCard();
    idx = card ? String(card.getAttribute('data-offer-index') || '') : pos;
    return idx + '|' + (wantsPaidShipping() ? 'paid' : 'free');
  }

  function normalizeText(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function getRateTitleText(item) {
    if (!item) return '';
    var el = item.querySelector('._rsi-modal-shipping-rates-item-title');
    if (!el) return normalizeText(item.textContent);
    var clone = el.cloneNode(true);
    var desc = clone.querySelector('._rsi-modal-shipping-rates-item-desc');
    if (desc && desc.parentNode) desc.parentNode.removeChild(desc);
    clone.querySelectorAll('svg').forEach(function (svg) {
      if (svg.parentNode) svg.parentNode.removeChild(svg);
    });
    return normalizeText(clone.textContent);
  }

  function getRatePriceText(item) {
    if (!item) return '';
    var el = item.querySelector('._rsi-modal-checkout-line-price, ._rsi-modal-shipping-rates-item-price');
    return el ? normalizeText(el.textContent) : '';
  }

  function isFlashTitle(title) {
    return FLASH_RE.test(String(title || ''));
  }

  function isGratisTitle(title) {
    var t = String(title || '');
    return FREE_RE.test(t) || /env[ií]o\s*gratis/i.test(t);
  }

  function isPaidStandardTitle(title) {
    var t = normalizeText(title);
    if (!t || isFlashTitle(t) || isGratisTitle(t)) return false;
    return /^env[ií]o(?:\s+(?:est[aá]ndar|standard|normal|regular))?$/i.test(t);
  }

  function isFreePriceText(text) {
    var t = normalizeText(text);
    if (!t) return false;
    if (FREE_RE.test(t)) return true;
    var digits = t.replace(/[^\d]/g, '');
    return digits === '' || /^0+$/.test(digits);
  }

  function parseDisplayNumber(text) {
    var t = normalizeText(text);
    if (!t || isFreePriceText(t)) return 0;
    if (!/\d/.test(t)) return 0;
    t = t.replace(/[^\d.,]/g, '');
    var hasComma = t.indexOf(',') !== -1;
    var hasDot = t.indexOf('.') !== -1;
    if (hasComma && hasDot) {
      t = t.lastIndexOf(',') > t.lastIndexOf('.') ? t.replace(/\./g, '').replace(',', '.') : t.replace(/,/g, '');
    } else if (hasComma && !hasDot) {
      var parts = t.split(',');
      t = parts[1] && parts[1].length === 3 && parts[0].length <= 3 ? t.replace(',', '') : t.replace(',', '.');
    }
    var n = parseFloat(t);
    return isFinite(n) ? n : 0;
  }

  function getShippingRateItems(form) {
    form = form || getForm();
    if (!form) return [];
    return Array.prototype.slice.call(form.querySelectorAll(ITEM_SEL));
  }

  function getConfiguredRates() {
    var settings =
      window._RSI_COD_FORM_SETTINGS ||
      (window._rsi && window._rsi.s) ||
      (window._rsiV2 && window._rsiV2.s) ||
      null;
    var rates =
      (settings && settings.shippingRates && settings.shippingRates.items_array) ||
      (settings && settings.shipping_rates && settings.shipping_rates.items_array) ||
      [];
    return Array.isArray(rates) ? rates : [];
  }

  function pricesMatch(price, amount) {
    if (!isFinite(price) || !isFinite(amount) || amount <= 0) return false;
    if (price === amount || price === Math.round(amount * 100)) return true;
    return Math.abs(price - amount) < 0.51 || Math.abs(price - amount * 100) < 0.51;
  }

  function rateConfigForItem(item) {
    if (!item) return null;
    var prio = item.getAttribute('data-priority');
    var rates = getConfiguredRates();
    for (var i = 0; i < rates.length; i++) {
      if (rates[i] && String(rates[i].priority) === String(prio)) return rates[i];
    }
    return null;
  }

  function configPrice(rate) {
    if (!rate) return NaN;
    return Number(rate.price);
  }

  function classifyItem(item) {
    var title = getRateTitleText(item);
    var cfg = rateConfigForItem(item);
    var cfgPrice = configPrice(cfg);
    var shown = parseDisplayNumber(getRatePriceText(item));
    var price = isFinite(cfgPrice) ? cfgPrice : shown;
    if (item.getAttribute('data-rsi-flash-rate') === '1' || isFlashTitle(title)) return 'flash';
    if (isGratisTitle(title)) return 'free';
    if (isPaidStandardTitle(title)) return 'paid';
    if (isFinite(price) && price === 0) return 'free';
    if (isFinite(price) && price > 0) return 'paid';
    return 'paid';
  }

  function findPaidStandardItem(items) {
    var named = [];
    var paid = [];
    var i;
    var item;
    var title;
    for (i = 0; i < items.length; i++) {
      item = items[i];
      title = getRateTitleText(item);
      if (isFlashTitle(title) || isGratisTitle(title)) continue;
      if (isPaidStandardTitle(title)) named.push(item);
      else if (classifyItem(item) === 'paid') paid.push(item);
    }
    if (named.length) return named[0];
    return paid.length ? paid[0] : null;
  }

  function findFreeStandardItem(items, flash, paid) {
    var i;
    var item;
    var title;
    for (i = 0; i < items.length; i++) {
      item = items[i];
      if (item === flash || item === paid) continue;
      title = getRateTitleText(item);
      if (isGratisTitle(title)) return item;
    }
    for (i = 0; i < items.length; i++) {
      item = items[i];
      if (item === flash || item === paid) continue;
      if (classifyItem(item) === 'free') return item;
    }
    return null;
  }

  function classifyRates(form) {
    var items = getShippingRateItems(form);
    var flash = null;
    var i;
    var item;
    var role;

    for (i = 0; i < items.length; i++) {
      item = items[i];
      role = classifyItem(item);
      item.setAttribute('data-rsi-qo-role', role);
      if (role === 'flash' && !flash) flash = item;
    }

    var paid = findPaidStandardItem(items);
    var free = findFreeStandardItem(items, flash, paid);

    return {
      items: items,
      flash: flash,
      free: free,
      paid: paid,
      paidWanted: wantsPaidShipping(),
    };
  }

  function hideItem(item) {
    if (!item) return;
    item.setAttribute('data-rsi-qo-hidden', '1');
    item.setAttribute('aria-hidden', 'true');
    item.removeAttribute('data-rsi-standard-rate');
  }

  function setHiddenPriorities(form, priorities) {
    if (!form) return;
    var unique = [];
    var seen = {};
    var i;
    var p;
    for (i = 0; i < priorities.length; i++) {
      p = String(priorities[i]);
      if (!p || seen[p]) continue;
      seen[p] = true;
      unique.push(p);
    }
    form.setAttribute('data-rsi-qo-hide-priority', unique.join(','));
    if (!state.hideStyle) {
      state.hideStyle = document.getElementById('rsi-qo-hide-prio-style');
      if (!state.hideStyle) {
        state.hideStyle = document.createElement('style');
        state.hideStyle.id = 'rsi-qo-hide-prio-style';
        (document.body || document.head).appendChild(state.hideStyle);
      }
    }
    if (!unique.length) {
      state.hideStyle.textContent = '';
      return;
    }
    var rules = unique.map(function (prio) {
      return (
        '#_rsi-cod-form-modal-form ._rsi-modal-shipping-rates-item[data-priority="' +
        prio +
        '"]{display:none!important;visibility:hidden!important}'
      );
    });
    state.hideStyle.textContent = rules.join('');
  }

  function intendedItem(info) {
    if (state.userPickedFlash && info.flash) return info.flash;
    return info.paidWanted ? info.paid : info.free;
  }

  function isVisibleRate(item, info) {
    if (!item || !info) return false;
    if (item === info.flash) return true;
    if (info.paidWanted) return item === info.paid;
    return item === info.free;
  }

  function layoutMatches(form, info) {
    if (!info || !info.items.length) return false;
    var standard = info.paidWanted ? info.paid : info.free;
    if (!standard) return false;
    var selected = form.querySelector(ITEM_SEL + '[data-selected="true"]:not([data-rsi-qo-hidden="1"])');
    if (selected !== standard && selected !== info.flash) return false;
    var i;
    var item;
    var hidden;
    for (i = 0; i < info.items.length; i++) {
      item = info.items[i];
      hidden = item.getAttribute('data-rsi-qo-hidden') === '1';
      if (isVisibleRate(item, info)) {
        if (hidden) return false;
      } else if (!hidden) {
        return false;
      }
    }
    return form.getAttribute('data-rsi-qo-paid') === (info.paidWanted ? '1' : '0');
  }

  function showItem(item, role) {
    if (!item) return;
    item.removeAttribute('data-rsi-qo-hidden');
    item.removeAttribute('aria-hidden');
    item.removeAttribute('hidden');
    if (item.style) {
      item.style.removeProperty('display');
      item.style.removeProperty('width');
      item.style.removeProperty('height');
    }
    if (role === 'flash') {
      item.setAttribute('data-rsi-flash-rate', '1');
      item.removeAttribute('data-rsi-standard-rate');
    } else {
      item.setAttribute('data-rsi-standard-rate', '1');
      item.removeAttribute('data-rsi-flash-rate');
    }
  }

  function syncPriorityInput(form, item) {
    if (!form || !item) return;
    var prio = item.getAttribute('data-priority');
    if (prio == null) return;
    var input = form.querySelector('input[name="shipping_rate_priority"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'shipping_rate_priority';
      form.appendChild(input);
    }
    if (input.value !== String(prio)) input.value = String(prio);
    try {
      if (window._rsi) {
        if (!Array.isArray(window._rsi.formData)) window._rsi.formData = [];
        var found = false;
        window._rsi.formData.forEach(function (entry) {
          if (entry && entry.name === 'shipping_rate_priority') {
            entry.value = String(prio);
            found = true;
          }
        });
        if (!found) window._rsi.formData.push({ name: 'shipping_rate_priority', value: String(prio) });
        if (window._rsi.shippingRates && window._rsi.s && window._rsi.s.shippingRates) {
          var rates = window._rsi.s.shippingRates.items_array || [];
          for (var i = 0; i < rates.length; i++) {
            if (rates[i] && String(rates[i].priority) === String(prio)) {
              window._rsi.shippingRates.currentRate = rates[i];
              window._rsi.shippingRates.savedRatePriority = Number(prio);
              break;
            }
          }
        }
      }
    } catch (eSync) { /* ignore */ }
  }

  function markSelected(form, item) {
    form = form || getForm();
    if (!form || !item) return;
    var items = getShippingRateItems(form);
    var i;
    for (i = 0; i < items.length; i++) {
      if (items[i] === item) {
        items[i].setAttribute('data-selected', 'true');
      } else if (items[i].getAttribute('data-selected') === 'true') {
        items[i].removeAttribute('data-selected');
      }
    }
    syncPriorityInput(form, item);
  }

  function clickRate(item) {
    if (!item) return false;
    if (item.getAttribute('data-selected') === 'true') {
      syncPriorityInput(getForm(), item);
      return false;
    }
    state.programmatic = true;
    try {
      item.click();
    } catch (eClick) { /* ignore */ }
    syncPriorityInput(getForm(), item);
    window.setTimeout(function () {
      state.programmatic = false;
    }, 200);
    return true;
  }

  function applyRateLayout(form, opts) {
    form = form || getForm();
    opts = opts || {};
    if (!form || !qoActive()) return;
    if (!form.querySelector(ITEM_SEL)) return;
    if (state.applying) return;
    if (!isFormOpen()) return;
    state.applying = true;

    try {
      stampOfferFlags();
      var info = classifyRates(form);
      var i;
      var item;
      var visibleStd = info.paidWanted ? info.paid : info.free;
      var hiddenStd = info.paidWanted ? info.free : info.paid;
      var hidePriors = [];

      form.setAttribute('data-rsi-qo-paid', info.paidWanted ? '1' : '0');

      if (!visibleStd) {
        if (info.paidWanted) {
          console.warn(
            '[QO shipping] No hay tarifa Envío Estandar (pago). Añádela en Releasit Form Designer.'
          );
        }
        form.setAttribute('data-rsi-qo-ready', '1');
        return;
      }

      // Tarifa que DEBE quedar seleccionada: Flash si el cliente la eligió; si no, la estándar
      // visible. Cambiar de oferta ya no la borra (antes volvía siempre a la estándar).
      if (opts.resetSelection === true) state.userRate = 'standard';
      var desired = state.userRate === 'flash' && info.flash ? info.flash : visibleStd;

      if (layoutMatches(form, info) && !opts.resetSelection && !opts.force) {
        var current = form.querySelector(ITEM_SEL + '[data-selected="true"]:not([data-rsi-qo-hidden="1"])');
        // Antes aceptaba cualquier tarifa visible (p.ej. el default que re-pintó Releasit)
        if (current === desired) {
          syncPriorityInput(form, current);
          form.setAttribute('data-rsi-qo-ready', '1');
          state.lastOfferKey = getOfferKey();
          return;
        }
      }

      if (hiddenStd && hiddenStd.getAttribute('data-priority') != null) {
        hidePriors.push(hiddenStd.getAttribute('data-priority'));
      }
      for (i = 0; i < info.items.length; i++) {
        item = info.items[i];
        if (item === info.flash || item === visibleStd) continue;
        if (item.getAttribute('data-priority') != null) {
          hidePriors.push(item.getAttribute('data-priority'));
        }
      }
      setHiddenPriorities(form, hidePriors);

      for (i = 0; i < info.items.length; i++) {
        item = info.items[i];
        if (item === info.flash) {
          showItem(item, 'flash');
        } else if (item === visibleStd) {
          showItem(item, 'standard');
        } else {
          hideItem(item);
        }
      }
      if (hiddenStd) hideItem(hiddenStd);

      var selectedVisible = form.querySelector(ITEM_SEL + '[data-selected="true"]:not([data-rsi-qo-hidden="1"])');
      if (
        opts.allowClick === false &&
        selectedVisible &&
        selectedVisible === desired
      ) {
        syncPriorityInput(form, selectedVisible);
        form.setAttribute('data-rsi-qo-ready', '1');
        return;
      }

      var offerKey = getOfferKey();
      var selected = form.querySelector(ITEM_SEL + '[data-selected="true"]:not([data-rsi-qo-hidden="1"])');
      var target = desired;

      if (target && selected !== target && opts.allowClick !== false) {
        clickRate(target);
      } else if (selected) {
        // Sin click: el input debe reflejar lo que realmente está seleccionado
        syncPriorityInput(form, selected);
      } else if (target) {
        syncPriorityInput(form, target);
      }

      form.setAttribute('data-rsi-qo-ready', '1');
      state.lastOfferKey = offerKey;
      paintOfferBadges();
    } finally {
      state.applying = false;
      if (typeof window._rsiSyncQoOfferFromPdp === 'function') {
        window._rsiSyncQoOfferFromPdp();
      }
    }
  }

  function scheduleApply(delay, opts) {
    if (!qoActive()) return;
    clearTimeout(state.applyTimer);
    state.applyTimer = setTimeout(function () {
      var form = getForm();
      if (!form || !isFormOpen()) return;
      applyRateLayout(form, opts || {});
    }, delay == null ? 80 : delay);
  }

  function stampOfferFlags() {
    var root = getQoRoot();
    var offers = document.querySelectorAll(
      '#rsi-cod-form-quantity-offers-hook ._rsi-quantity-offers-offer-container, #_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container'
    );
    var cards = root ? root.querySelectorAll('.qov4__card') : [];
    var i;
    var offer;
    var pos;
    var card;
    var isFree;
    for (i = 0; i < offers.length; i++) {
      offer = offers[i];
      pos = offer.getAttribute('data-offer-pos');
      if (pos == null || pos === '') {
        pos = String(i);
        offer.setAttribute('data-offer-pos', pos);
      }
      card = pdpCardForOfferPos(pos) || cards[Number(pos)] || cards[i];
      isFree = card ? parseBoolFlag(card.getAttribute('data-free-shipping'), true) : true;
      offer.setAttribute('data-free-shipping', isFree ? 'true' : 'false');
    }
  }

  function paintOfferBadges() {
    stampOfferFlags();
    var root = getQoRoot();
    if (!root) return;
    var label = (root.getAttribute('data-free-shipping-label') || 'ENVÍO GRATIS').trim();
    var offers = document.querySelectorAll(
      '#rsi-cod-form-quantity-offers-hook ._rsi-quantity-offers-offer-container, #_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container'
    );
    for (var i = 0; i < offers.length; i++) {
      var offer = offers[i];
      var pos = offer.getAttribute('data-offer-pos');
      if (pos == null) pos = String(i);
      var card = pdpCardForOfferPos(pos) || root.querySelectorAll('.qov4__card')[Number(pos)];
      var isFree = card ? parseBoolFlag(card.getAttribute('data-free-shipping'), true) : true;
      var badge = offer.querySelector('.rsi-qo-ship-badge');
      if (!isFree) {
        if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
        continue;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'rsi-qo-ship-badge';
        badge.setAttribute('aria-hidden', 'true');
        offer.insertBefore(badge, offer.firstChild);
      }
      badge.textContent = label;
    }
  }

  /**
   * Corrige en el mismo instante de la mutación (microtask, antes de pintar) cuando Releasit
   * re-pinta las tarifas o cambia la seleccionada. Antes se corregía ~160ms después → se veía
   * la tarifa equivocada (o ninguna) y luego saltaba.
   */
  function enforceNow() {
    var form = getForm();
    if (!form || !isFormOpen() || !qoActive() || state.applying) return;
    // Tap del cliente en curso sobre una tarifa: no pelear (en iOS Releasit puede seleccionar antes del click)
    if (Date.now() < state.tapLockUntil) {
      scheduleApply(Math.max(60, state.tapLockUntil - Date.now() + 40));
      return;
    }
    var now = Date.now();
    if (now - state.enforceWindowStart > 1000) {
      state.enforceWindowStart = now;
      state.enforceCount = 0;
    }
    // Anti-loop: si Releasit insistiera, dejar el ciclo normal
    if (++state.enforceCount > 8) {
      scheduleApply(120);
      return;
    }
    applyRateLayout(form, {});
  }

  function watchRates() {
    var form = getForm();
    if (!form) return;
    if (!form.querySelector('._rsi-modal-shipping-rates')) return;
    if (state.ratesObserver) state.ratesObserver.disconnect();
    state.ratesObserver = new MutationObserver(function (mutations) {
      if (state.applying) return;
      var touches = false;
      for (var i = 0; i < mutations.length && !touches; i++) {
        var m = mutations[i];
        var t = m.target;
        if (m.type === 'attributes') {
          if (t && t.matches && t.matches(ITEM_SEL)) touches = true;
          continue;
        }
        if (t && t.closest && t.closest('._rsi-build-block-shipping-rates, ._rsi-modal-shipping-rates')) {
          touches = true;
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.matches('._rsi-modal-shipping-rates, ' + ITEM_SEL) || n.querySelector(ITEM_SEL))) {
            touches = true;
            break;
          }
        }
      }
      if (touches) enforceNow();
    });
    // Form completo (no solo el contenedor): sobrevive a que Releasit reemplace el contenedor
    state.ratesObserver.observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-selected'],
    });
  }

  function waitForRatesAndApply() {
    clearTimeout(state.bootTimer);
    var tries = 0;
    function tick() {
      var form = getForm();
      if (form && form.querySelector(ITEM_SEL)) {
        applyRateLayout(form, { force: true });
        watchRates();
        watchOffers();
        return;
      }
      tries += 1;
      if (tries < 30) state.bootTimer = setTimeout(tick, 50);
    }
    tick();
  }

  function onFormOpen() {
    state.userPickedFlash = false;
    state.userRate = 'standard';
    state.lastLayoutKey = '';
    state.quietUntil = 0;
    setDriver('pdp');
    var form = getForm();
    if (form) form.removeAttribute('data-rsi-qo-ready');
    if (window.__qov5Instances && window.__qov5Instances.length) {
      window.__qov5Instances.forEach(function (inst) {
        if (inst && typeof inst.syncFromPdpImmediate === 'function') inst.syncFromPdpImmediate();
      });
    }
    state.lastOfferKey = '';
    state.clickedLayout = '';
    state.pendingLayout = '';
    waitForRatesAndApply();
    watchOffers();
  }

  function onFormClose() {
    state.userPickedFlash = false;
    state.userRate = 'standard';
    state.lastOfferKey = '';
    setDriver('pdp');
    state.lastLayoutKey = '';
    state.clickedLayout = '';
    state.pendingLayout = '';
    state.quietUntil = 0;
    clearTimeout(state.bootTimer);
    clearTimeout(state.applyTimer);
    var form = getForm();
    if (form) {
      form.removeAttribute('data-rsi-qo-ready');
      form.removeAttribute('data-rsi-qo-paid');
      form.removeAttribute('data-rsi-qo-amount');
      form.removeAttribute('data-rsi-qo-hide-priority');
    }
    if (state.hideStyle) state.hideStyle.textContent = '';
    if (state.ratesObserver) {
      state.ratesObserver.disconnect();
      state.ratesObserver = null;
    }
    if (state.offersObserver) {
      state.offersObserver.disconnect();
      state.offersObserver = null;
    }
    if (typeof window._rsiStopQoOfferSync === 'function') {
      window._rsiStopQoOfferSync();
    }
  }

  function watchOffers() {
    var box = document.querySelector(
      '#rsi-cod-form-quantity-offers-hook ._rsi-quantity-offers, #_rsi-cod-form-modal-form ._rsi-quantity-offers'
    );
    if (!box) box = document.querySelector('#rsi-cod-form-quantity-offers-hook, #_rsi-cod-form-modal-form');
    if (!box) return;
    if (state.offersObserver) state.offersObserver.disconnect();
    state.offersObserver = new MutationObserver(function (mutations) {
      if (state.applying || state.programmatic) return;
      var relevant = false;
      var i;
      var target;
      for (i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' && (mutations[i].addedNodes.length || mutations[i].removedNodes.length)) {
          relevant = true;
          break;
        }
        target = mutations[i].target;
        if (
          target &&
          target.classList &&
          target.classList.contains('_rsi-quantity-offers-offer-container')
        ) {
          relevant = true;
          break;
        }
      }
      if (relevant) {
        enforceNow(); // layout/selección correctos ya en este frame
        onOfferChanged();
      }
    });
    state.offersObserver.observe(box, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function onOfferChanged() {
    if (!isFormOpen()) return;
    scheduleApply(80);
  }

  function handleShippingClick(e) {
    if (state.programmatic && !e.isTrusted) return;
    if (!e.target || !e.target.closest) return;
    var item = e.target.closest(ITEM_SEL);
    if (!item) return;
    state.tapLockUntil = 0;
    if (item.getAttribute('data-rsi-qo-hidden') === '1') {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    state.userRate =
      item.getAttribute('data-rsi-flash-rate') === '1' || isFlashTitle(getRateTitleText(item))
        ? 'flash'
        : 'standard';
    window.setTimeout(function () {
      var form = getForm();
      if (!form) return;
      var selected = form.querySelector(ITEM_SEL + '[data-selected="true"]:not([data-rsi-qo-hidden="1"])');
      if (selected) syncPriorityInput(form, selected);
    }, 30);
  }

  function hookModalBus() {
    if (!window._rsiModalBus || window._rsiModalBus.__qoShipSwapHooked) return;
    window._rsiModalBus.__qoShipSwapHooked = true;
    var originalOpen = window._rsiModalBus.open.bind(window._rsiModalBus);
    window._rsiModalBus.open = function () {
      var wasOpen = window._rsiModalBus._isOpen;
      originalOpen();
      if (!wasOpen) onFormOpen();
    };
    var originalClose = window._rsiModalBus.close.bind(window._rsiModalBus);
    window._rsiModalBus.close = function () {
      var wasOpen = window._rsiModalBus._isOpen;
      originalClose();
      if (wasOpen) onFormClose();
    };
  }

  function selectedVisibleItem(form) {
    var selected = form.querySelector(ITEM_SEL + '[data-selected="true"]:not([data-rsi-qo-hidden="1"])');
    if (selected) return selected;
    var info = classifyRates(form);
    if (state.userRate === 'flash' && info.flash) return info.flash;
    return info.paidWanted ? info.paid : info.free;
  }

  function prepareSubmit(form) {
    if (!form || !qoActive()) return;
    applyRateLayout(form);
    var item = selectedVisibleItem(form);
    if (item) {
      if (item.getAttribute('data-selected') !== 'true') clickRate(item);
      syncPriorityInput(form, item);
    }
  }

  function patchFormDataPriority(payload, priority) {
    if (!payload || priority == null) return payload;
    if (Array.isArray(payload.formData)) {
      var found = false;
      payload.formData.forEach(function (entry) {
        if (entry && entry.name === 'shipping_rate_priority') {
          entry.value = String(priority);
          found = true;
        }
      });
      if (!found) payload.formData.push({ name: 'shipping_rate_priority', value: String(priority) });
    }
    payload.shipping_rate_priority = String(priority);
    return payload;
  }

  function patchOutgoingBody(body) {
    var form = getForm();
    if (!form || !qoActive()) return body;
    var item = selectedVisibleItem(form);
    if (!item) return body;
    var priority = item.getAttribute('data-priority');
    if (priority == null) return body;

    if (typeof body === 'string' && body) {
      try {
        var parsed = JSON.parse(body);
        if (parsed && typeof parsed === 'object') {
          return JSON.stringify(patchFormDataPriority(parsed, priority));
        }
      } catch (eJson) { /* ignore */ }
      return body;
    }
    if (body && typeof body === 'object') {
      patchFormDataPriority(body, priority);
    }
    return body;
  }

  function looksLikeOrderCreate(url, body) {
    var u = String(url || '').toLowerCase();
    if (/rsi-cod-form|create-order|releas|cod-?form/.test(u)) return true;
    if (typeof body === 'string' && /shipping_rate_priority/.test(body)) return true;
    return false;
  }

  function installNetworkHooks() {
    if (window.__rsiQoShipSwapNet) return;
    window.__rsiQoShipSwapNet = true;

    if (window.fetch) {
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          init = init || {};
          if (looksLikeOrderCreate(url, init.body) && qoActive()) {
            var form = getForm();
            if (form) prepareSubmit(form);
            if (init.body != null) {
              init = Object.assign({}, init, { body: patchOutgoingBody(init.body) });
            }
          }
        } catch (eFetch) { /* ignore */ }
        return nativeFetch(input, init);
      };
    }

    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
      var nativeOpen = window.XMLHttpRequest.prototype.open;
      var nativeSend = window.XMLHttpRequest.prototype.send;
      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__rsiQoUrl = url;
        return nativeOpen.apply(this, arguments);
      };
      window.XMLHttpRequest.prototype.send = function (body) {
        try {
          if (looksLikeOrderCreate(this.__rsiQoUrl, body) && qoActive()) {
            var form = getForm();
            if (form) prepareSubmit(form);
            body = patchOutgoingBody(body);
          }
        } catch (eSend) { /* ignore */ }
        return nativeSend.call(this, body);
      };
    }
  }

  function hookRsiAjax() {
    var rsi = window._rsi;
    if (!rsi || rsi.__qoShipSwapAjax) return;
    if (rsi.u && typeof rsi.u.ajax === 'function') {
      var origAjax = rsi.u.ajax.bind(rsi.u);
      rsi.u.ajax = function (method, url, body) {
        try {
          if (String(method || '').toUpperCase() === 'POST' && looksLikeOrderCreate(url, body) && qoActive()) {
            var form = getForm();
            if (form) prepareSubmit(form);
            body = patchOutgoingBody(body);
            arguments[2] = body;
          }
        } catch (eAjax) { /* ignore */ }
        return origAjax.apply(rsi.u, arguments);
      };
    }
    if (rsi.form && typeof rsi.form.getFormData === 'function') {
      var origGet = rsi.form.getFormData.bind(rsi.form);
      rsi.form.getFormData = function () {
        var data = origGet.apply(rsi.form, arguments);
        try {
          if (qoActive()) {
            var form = getForm();
            var item = form && selectedVisibleItem(form);
            if (item) data = patchFormDataPriority(data, item.getAttribute('data-priority'));
          }
        } catch (eGet) { /* ignore */ }
        return data;
      };
    }
    rsi.__qoShipSwapAjax = true;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!qoActive()) return;
      handleShippingClick(e);
      if (e.target && e.target.closest) {
        var pdpCard = e.target.closest('.qov4__card');
        var modalOffer = e.target.closest('._rsi-quantity-offers-offer-container');
        if (pdpCard && !e.target.closest('#_rsi-cod-form-modal, #rsi-cod-form-quantity-offers-hook')) {
          setDriver('pdp');
          window.setTimeout(onOfferChanged, 80);
        } else if (modalOffer && !window.__rsiQoSyncingOffers) {
          setDriver('modal');
          if (typeof window._rsiStopQoOfferSync === 'function') {
            window._rsiStopQoOfferSync();
          }
          window.setTimeout(onOfferChanged, 80);
        }
      }
      var btn = e.target && e.target.closest && e.target.closest(
        '#_rsi-cod-form-modal-form ._rsi-modal-submit-button, #_rsi-cod-form-modal-form button[type="submit"]'
      );
      if (btn) prepareSubmit(getForm());
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      if (e.target && e.target.id === '_rsi-cod-form-modal-form') prepareSubmit(e.target);
    },
    true
  );

  // Inicio de tap sobre una tarifa: pausar la corrección hasta el click (o 800ms)
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (!e.isTrusted || !e.target || !e.target.closest) return;
      if (e.target.closest(ITEM_SEL)) state.tapLockUntil = Date.now() + 800;
    },
    true
  );

  document.addEventListener('rsi-qo-free-shipping-change', function () {
    onOfferChanged();
  });

  installNetworkHooks();
  hookModalBus();

  setInterval(function () {
    hookModalBus();
    hookRsiAjax();
  }, 2000);

  new MutationObserver(function (mutations) {
    var relevant = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].target && mutations[i].target.id === '_rsi-cod-form-modal') {
        relevant = true;
        break;
      }
    }
    if (!relevant) return;
    var nowOpen = isFormOpen();
    if (nowOpen && !state.formWasOpen) onFormOpen();
    else if (!nowOpen && state.formWasOpen) onFormClose();
    state.formWasOpen = nowOpen;
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  window._rsiSyncQoFreeShipping = function () {
    onOfferChanged();
  };

  window._rsiQoShippingReport = function () {
    var form = getForm();
    var info = form ? classifyRates(form) : {};
    var report = {
      freeShipping: getQoFreeShipping(),
      paidWanted: wantsPaidShipping(),
      userPickedFlash: state.userPickedFlash,
      freeTitle: info.free && getRateTitleText(info.free),
      paidTitle: info.paid && getRateTitleText(info.paid),
      flashTitle: info.flash && getRateTitleText(info.flash),
      freePriority: info.free && info.free.getAttribute('data-priority'),
      paidPriority: info.paid && info.paid.getAttribute('data-priority'),
      flashPriority: info.flash && info.flash.getAttribute('data-priority'),
      selected: form && (form.querySelector(ITEM_SEL + '[data-selected="true"]') || {}).getAttribute &&
        form.querySelector(ITEM_SEL + '[data-selected="true"]').getAttribute('data-priority'),
      rates: getConfiguredRates().map(function (r) {
        return r && { title: r.title, price: r.price, priority: r.priority, type: r.type };
      }),
    };
    try {
      console.info('[QO shipping]', report);
    } catch (eRep) { /* ignore */ }
    return report;
  };
})();
